<template>
  <generic-modal :title="$t('variable set')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.name"
                :placeholder="$t('variable set name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("options") }}</label>
            <div class="button" @click="add_variable">
              <span class="icon">
                <i class="fa fa-plus"></i>
              </span>
              <span>{{ $t("add variable") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="meta.settings && meta.settings.variables">
        <div class="title is-6">{{ $t("variable list") }}</div>
        <div
          class="columns mb-0"
          v-for="(variable, vidx) in meta.settings.variables"
          :key="vidx"
        >
          <div class="column">
            <div class="field">
              <label class="label" v-if="vidx == 0">{{ $t("name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="variable.name" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label" v-if="vidx == 0">{{ $t("value") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="variable.value" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/ngine/variable-set", { uuid: uuid })
        .then((response) => {
          v.meta = response;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    save() {
      let v = this;
      v.$root.loader(true);
      if (v.meta.uuid) {
        post("/ngine/variable-set", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      } else {
        put("/ngine/variable-set", v.meta)
          .then((process_uuid) => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {
          variables: [{ name: "", value: "" }],
        },
      };
      v.error = "";
    },
    add_variable() {
      let v = this;
      if (!v.meta.settings.variables) v.meta.settings.variables = [];
      v.meta.settings.variables.push({ name: "", value: "" });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
